module.exports = __webpack_public_path__ + "e0bc7bb1e7695d5ae991b69cdf18fd9d.svg";